<template>
    <div class=" mt-4 mb-4">
        <div class="bg-transparent">
            <div class="row">
                <div class="col-lg-4 col-12">
                    <div class="d-flex align-items-center position-relative  justify-content-center">
                        <img class="py-2 logo-height" :src="Angelone" />
                    </div>
                </div>
                <div class="col-lg-4 col-12">
                    <div class="d-flex align-items-center position-relative  justify-content-center">
                        <img class="py-2 logo-height" :src="Kite" />
                    </div>
                </div>
                <div class="col-lg-4 col-12">
                    <div class="d-flex align-items-center position-relative  justify-content-center">
                        <img class="py-2 logo-height" :src="Iifl" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Angelone from "@/assets/img/Angelone.png";
import Kite from "@/assets/img/kite-logo.png";
import Iifl from "@/assets/img/iifl-logo.png";
export default {
    name: "BrokerCard",
    data() {
        return {
            Angelone: Angelone,
            Kite: Kite,
            Iifl: Iifl,
        }
    }
}
</script>
<style></style>